import React from 'react';
import { LinearProgress } from '@mui/material';


const Spinner = () => <LinearProgress style={{ width: '100%', marginTop:'2rem' }} />;

export default Spinner;
